import React, { useRef } from "react";
import { useNavigate } from "@tanstack/react-router";
import ArticleCard from "../articles/ArticleCard";
import MagneticButton from "../motion/MagneticButton";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { getAllArticles } from "../../lib/articles";

/**
 * Home teaser: the 3 newest articles. Reads only meta.ts, so no article
 * bodies are loaded.
 */
const LatestArticles: React.FC = () => {
  const ref = useRef<HTMLElement>(null);
  const navigate = useNavigate();
  useScrollReveal(ref);

  const latest = getAllArticles().slice(0, 3);
  if (latest.length === 0) return null;

  return (
    <section ref={ref} id="latest-articles" className="my-16 md:my-24">
      <div data-reveal className="mb-8">
        <p className="text-cyan-400 font-mono text-sm tracking-widest uppercase mb-2">
          Articles
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-white">
          Latest from the blog
        </h2>
      </div>

      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {latest.map((article) => (
          <ArticleCard key={article.slug} article={article} />
        ))}
      </div>

      <div data-reveal className="mt-8 text-center">
        <MagneticButton
          className="px-6 py-3 rounded-lg bg-cyan-500 text-slate-950 font-semibold hover:bg-cyan-400 transition-colors"
          onClick={() => navigate({ to: "/articles" })}
        >
          View all articles
        </MagneticButton>
      </div>
    </section>
  );
};

export default LatestArticles;
